import * as z from 'zod';

import { statusFormSchema } from '@/_schemas/status-input';

import { tcTemplateQuerySchema } from './tc-template-query-schema';

export const tcTemplateFormSchema = tcTemplateQuerySchema
  .omit({
    name: true,
    status: true,
    sku: true,
    notes: true,
    agreements_count: true,
  })
  .extend({
    name: z.string().min(3),
    sku: z.string(),
    notes: z.string(),
    status: statusFormSchema,
  });

export type TcTemplateFormSchema = z.infer<typeof tcTemplateFormSchema>;
